export default __webpack_public_path__ + "static/media/gallery-wip-clamp-lever_11.79fdcc93.jpg";